import React from 'react';
import { useIsMobile } from '@/lib/utils/useIsMobile';
import Events from '@/pages/events';
import MobileEvents from '@/pages/MobileEvents';

export function ResponsiveEvents() {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileEvents />;
  }
  
  return <Events />;
}